import React, { useEffect, useState } from "react";
import { DownloadIcon } from "@heroicons/react/outline";
import axios from "axios";

function Downloads() {
  const [version, setVersion] = useState("");
  useEffect(() => {
    // axios
    //   .get(
    //     "https://repository.anthemav.com/anthem/mrx_x40/meta/AVM_90_current.json"
    //   )
    //   .then((res) => {
    //     const str = res.data.version;
    //     const pos = str.lastIndexOf(".");
    //     const result = str.slice(0, pos);
    //     setVersion(result);
    //   })
    //   .catch((err) => console.log(err));
  }, []);

  const downloads = [
    {
      group: "Manuals & Literature",
      files: [
        {
          title: "AVM 90/70 Manual",
          file: "http://manuals.anthemav.com/mrx-avm/en",
        },
        {
          title: "AVM 90 Data Sheet",
          file: "https://anthemav.com/downloads/anthem-avm90-spec-sheet-rev6.pdf",
        },
        {
          title: "AVM 90/70 Technical Drawings",
          file: "https://www.anthemav.com/downloads/MRX-AVM-Dimensional.PDF",
        },
        {
          title: "AVM Quick Start Guide",
          file: "https://www.anthemav.com/downloads/anthem-mrx-1140-740-540-avm90-70-quick-start-guide-051121-ONLINE.pdf",
        },
        {
          title: "AVM 90 Firmware change log",
          file: "https://www.anthemav.com/support/change_log.php?version=2.3.213",
        },
      ],
    },
    {
      group: "Remote Codes",
      files: [
        {
          title: "MRXx40/AVM90/AVM70 IP/RS-232 Codes",
          file: "https://www.anthemav.com/downloads/MRX-x40-AVM-70-90-IP-RS-232-v5.xls",
        },
        {
          title: "MRXx40/AVM90/AVM70 IR Hex",
          file: "https://www.anthemav.com/downloads/AVM-MRXx40-IR-hex.xlsx",
        },
      ],
    },
    {
      group: "Control drivers",
      files: [
        {
          title: "Control4 AVM90 Driver",
          file: "https://www.anthemav.com/downloads/receiver_Anthem_AVM_90.c4z",
        },
        {
          title: "Crestron MRXx40 / AVM 90 / AVM 70 Module",
          file: "https://www.anthemav.com/downloads/crestron-anthem-mrxx40-1.0.1.zip",
        },
        {
          title: "Elan MRXx40 Module",
          file: "https://www.anthemav.com/downloads/ELAN-Anthem_MRX_x40.zip",
        },
        {
          title: "RTI MRXx40 / AVM 90 / AVM 70 Driver",
          file: "https://www.anthemav.com/downloads/rti-anthem-mrxx40-1.0.0.zip",
        },
        {
          title: "URC MRXx40 / AVM 90 / AVM 70 Module",
          file: "https://www.anthemav.com/downloads/urc-anthem-mrxx40-1.0.0.zip",
        },
      ],
    },
  ];
  return (
    <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
      <dl className="space-y-8 px-4 sm:px-6 sm:space-y-6">
        <ul className="">
          {downloads.map((file) => (
            <li className="py-5 ">
              <p className="uppercase font-bold text-sm lg:text-md text-gray-900 border-b-2 border-x-gray-700 mb-3">
                {file.group}
              </p>
              <ul>
                {file.files?.map((s) => (
                  <li className="hover:bg-gray-100 mb-3">
                    <p className="font-medium text-sm lg:text-md text-gray-700 ">
                      <a
                        target={"_blank"}
                        href={s.file}
                        className="flex items-center"
                        rel="noreferrer"
                      >
                        <span className="inline-block mr-2">
                          <DownloadIcon className="h-4" />
                        </span>
                        <span>{s.title}</span>
                      </a>
                    </p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </dl>
    </div>
  );
}

export default Downloads;
